const natural = {
  state: {
    naturalInfo: {},
  },
  mutations: {
    CHANGENATURALINFO(state, data) {
      state.naturalInfo = Object.assign({}, state.naturalInfo, data);
    },
  },
  actions: {
    changeNaturaInfo({ commit }, data) {
      return new Promise((resolve) => {
        commit('CHANGENATURALINFO', data);
        resolve();
      });
    },
  },
};

export default natural;
